/**
 * Whether the browser exposes document.modelContext (native or polyfilled).
 */
export const isWebMCPSupported = (): boolean =>
  typeof document !== 'undefined' && 'modelContext' in document;
